/* eslint-disable no-unused-vars */
import { toast } from 'react-toastify';
import Toast from '../components/Common/Toaster/Toaster';
export const FETCH_ALL_PATIENTS = 'FETCH_ALL_PATIENTS';
export const SET_VIEW_DETAILS = 'SET_VIEW_DETAILS';
export const SET_PDF_BLOB = 'SET_PDF_BLOB';
export const SET_INVOICE_BLOB = 'SET_INVOICE_BLOB';
const initialState = {
  allPatients: [],
  pdfBlob: null,
  viewDetails: false,
  invoiceBlob: null
};

const PatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PATIENTS:
      return {
        ...state,
        allPatients: action.payload,
      };
    case SET_VIEW_DETAILS:
      return {
        ...state,
        viewDetails: action.payload,
      };
      case SET_PDF_BLOB:
        return {
          ...state,
          pdfBlob: action.payload,
        };
        case SET_INVOICE_BLOB:
          return {
            ...state,
            invoiceBlob: action.payload,
          };
    default:
      return state;
  }
};

export default PatientReducer;

export const fetchAllPatients = (patients) => ({
  type: FETCH_ALL_PATIENTS,
  payload: patients,
});

export const setPdfBlob = (blob) => ({
  type: SET_PDF_BLOB,
  payload: blob,
});

export const setInvoiceBlob = (blob) => ({
  type: SET_INVOICE_BLOB,
  payload: blob,
});

export const setViewDetails = (viewDetails) => ({
  type: SET_VIEW_DETAILS,
  payload: viewDetails,
});

export const fetchPatients = () => {
  return async (dispatch) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_api_url}/api/get/patientadmin/info`,
        {
          method: 'GET',
        }
      );
      if (!response.ok) {
        throw new Error('Failed to get patients');
      }
      const val = await response.json();
      dispatch(fetchAllPatients(val));
    } catch (error) {}
  };
};

export const fetchPdfUrl = (data) => {
  return async (dispatch) => {
    try {
      // Fetch patient details
      const patientResponse = await fetch(
        `${process.env.REACT_APP_api_url}/api/download/patient/info/${data.id}/${data.visit}.pdf`,
        {
          method: 'GET',
        }
      );
      if (!patientResponse.ok) {
        Toast.error('Failed to get patient details');
        throw new Error('Failed to get patient details');
      }
      const patientBlob = await patientResponse.blob();

      // Fetch invoice details
      const invoiceResponse = await fetch(
        `${process.env.REACT_APP_api_url}/api/download/invoice/info/${data.id}/${data.visit}.pdf`,
        {
          method: 'GET',
        }
      );
      if (!invoiceResponse.ok) {
        Toast.error('Failed to get invoice details');
        throw new Error('Failed to get invoice details');
      }
      const invoiceBlob = await invoiceResponse.blob();

      dispatch(setPdfBlob(patientBlob));
      dispatch(setInvoiceBlob(invoiceBlob));
      dispatch(setViewDetails(true));
      return(invoiceBlob)
    } catch (error) {
      Toast.error('Failed to get patient or invoice details');
      return(error)
    }
  };
};
